export default __webpack_public_path__ + "static/media/pug.ed65142c.gif";